 <template>
    <div>
        <span> {{ numberFormatter(scope.row[scope.column.property], scope.$index) }} </span>
    </div>
</template>

<script>
import formatters from '@/services/formatters';

export default {
    props: {
        scope: Object,
    },
    methods: {
        numberFormatter(cellValue, index) {
            
            // percentCells: sem casas decimais
            var percentCells = [1, 9, 10, 18]
            
            //smallPercentCells: 1 casa decimal
            var smallPercentCells = [3, 6, 8, 12, 13, 15, 17, 20, 25, 26]
            
            //miniPercentCell: 2 casas decimais
            var miniPercentCells = [5]
            
            var currencyCells = [0, 2, 4, 7, 11, 14, 16, 19, 21, 22, 23, 24]
            if(percentCells.includes(index)){
                return formatters.numberFormatter(cellValue, 1, 'percent', 0)
            }
            if(smallPercentCells.includes(index)){
                return formatters.numberFormatter(cellValue, 1, 'percent', 1)
            }
            if(miniPercentCells.includes(index)){
                return formatters.numberFormatter(cellValue, 1, 'percent', 2)
            }
            if(currencyCells.includes(index)){
                return formatters.numberFormatter(cellValue, 1, 'currency',0)
            }
        },
    }
}
</script>